// extracted by css-extract-rspack-plugin
export default {"root":"KLcL2O","upscaled-indicator":"nktFwD","upscaledIndicator":"nktFwD"};